<template>
    <BaseDialog
        :visible="dialog"
        :type="type"
        :form="form"
        title="kontrolní místo"
        @close="dialog=false"
        @process="processForm"
        max-width="1400px"
    >
        <v-text-field
                v-model="form.name"
                type="text"
                label="Jméno"
                :rules="formRules.name"
        />
        <v-select
                :items="users"
                item-text="username"
                item-value="id"
                v-model="form.user"
                label="Uživatel"
                required
                :rules="formRules.user"
                v-if="$store.state.user.logged.isSuperuser"
        ></v-select>

        <v-autocomplete
                :items="ticketsets"
                item-text="name"
                item-value="id"
                v-model="form.ticketsetIds"
                label="Sady vstupenek"
                required
                multiple
        ></v-autocomplete>
    </BaseDialog>
</template>

<script>
    import BaseDialogMixin from '../../mixins/BaseDialogMixin'

    export default {
        mixins: [BaseDialogMixin],

        data: () => ({
            form: {
                id: 0,
                name: '',
                user: null,
                ticketsetIds: []
            },
            formRules: {
                name: [v => v !== '' || 'Vyplňte hodnotu'],
                user: []
            }
        }),

        mounted () {
            if (this.$store.state.user.logged.isSuperuser) {
                this.$store.dispatch('user/list')
            }
        },

        computed: {
            users () {
                return this.$store.state.user.list
            },
            ticketsets() {
                return this.$store.state.ticketset.list.map(ticketset => {
                    return {
                        id: ticketset.id,
                        name: `${ticketset.name} (${ticketset.event.name})`
                    }
                })
            }
        },

        methods: {
            show() {
                BaseDialogMixin.methods.show.bind(this)()

                if (this.type === 'edit') {
                    const activeCheckpoint = this.$store.state.checkpoint.list.find(
                        checkpoint => checkpoint.id === this.form.id)
                    this.form.ticketsetIds = activeCheckpoint.ticketsets.map(ticketset => ticketset.id)
                }
            },
            postShow () {
                if (this.$store.state.user.logged.isSuperuser) {
                    this.formRules['user'] = [v => v !== '' || 'Vyberte uživatele']
                } else {
                    this.formRules['user'] = []
                }
            }
        }
    }
</script>
